import { Link } from '@mui/material';
import { JSX } from 'react';

const steps: (string | JSX.Element)[] = [
  'Click on the Copy To Clipboard button on this modal. It will copy a unique code for the bus.',
  <>
    Go to the following link to generate the code:
    <br />
    <Link
      href='https://www.qr-code-generator.com'
      target='_blank'
      rel='noopener noreferrer'
      underline='hover'
      sx={{ fontWeight: 'bold' }}
    >
      https://www.qr-code-generator.com
    </Link>
  </>,
  'Click on TEXT.',
  'Paste the unique code copied from the admin portal.',
  'As soon as you paste the unique code, the QR code is generated.',
  'Login to the driver app by scanning this QR code.',
  'You can also download the QR code for future reference.'
];

export default steps;
